import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { PointsRequestData } from './pointsRequest.types';
const getPointsRequest = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<PointsRequestData[]>>('/pointsRequest')).data;
};

export const pointsRequestQueries = {
  all: () => ['pointsRequest'],

  list: () =>
    queryFactoryOptions<ApiResponse<PointsRequestData[]>>({
      queryKey: [...pointsRequestQueries.all(), 'list'],
      queryFn: (client) => getPointsRequest(client),
    }),
};
